import React, { useState, useEffect, useContext, useRef } from "react";
import * as S from "./styles";
import iconUser from "../../assets/user/account-circle.svg";

import Button from "../Button";
import api from "../../services/api";
import { BiTrash } from "react-icons/bi";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import InputMask from "react-input-mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { toast } from "react-toastify";
import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import { Formik, Form } from "formik";

import PopUp from "../../components/PopUp";
import SkeletonListItem from "../SkeletonListItem";
import BorderedAutoCompleteSearchRoles from "../BorderedAutoCompleteSearchRoles";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function WhitelistComponent({ history, pageFilter }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit } = useContext(Context);
  const [popupOpen, setPopupOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({ id: null, cpf: null });
  const [loading, setLoading] = useState(false);

  const [listRoles, setListRoles] = useState([]);
  const [selected, setSelected] = useState(false);
  const [roleId, setRoleId] = useState(null);

  const [users, setUsers] = useState([]);
  const [initialState, setInitialState] = useState({
    addCPF: null,
    role: null,
    id: null,
  });
  function onBlurCPF(cpf) {
    if (cpf.length !== 11) {
      return;
    }
  }

  async function getAllData(page = 0) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/api/whitelist/buscar?page=${page}&size=${pageLimit}`
      );

      if (response && (response.status === 201 || response.status === 200)) {
        setUsers(response.data.content);
        setPage(page);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setUsers([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar aos usuários.");
      }

      setIsLoading(false);
    } catch (err) {
      setTotalPages(0);
      setTotalElements(0);
      setUsers([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar aos usuários.");
      }
    }
    setLoading(!loading);
  }

  function getUserByCPF(cpf) {
    let user = null;

    if (cpf !== null) {
      users.every(function (currUser) {
        if (cpf === currUser.cpf) {
          user = currUser;

          return false;
        }

        return true;
      });
    }

    return user;
  }

  useEffect(() => {
    if (pageFilter) {
      setPage(pageFilter);
    }

    getAllData(pageFilter);
  }, [pageFilter]);

  const reloadPage = (page) => {
    history.replace(`?page=${page}`);
  };

  const sendData = async (dataForm) => {
    if (!dataForm || dataForm === null || dataForm === "") {
      toast.error("Preencha ao menos um CPF válido.");
      return;
    }

    const dataSending = {
      cpf: dataForm,
      papel: {
        id: roleId,
      },
    };

    // Caso exista usuário cadastrado, este será atualizado
    const newUser = getUserByCPF(dataForm);

    try {
      let response = undefined;

      // Cadastra
      if (newUser === null) {
        response = await api.post("/api/whitelist", dataSending);
      }
      // Atualiza
      else {
        const id = newUser?.id;
        response = await api.put(`/api/whitelist/${id}`, dataSending);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        newUser === null
          ? toast.success("Dados cadastrados com sucesso!")
          : toast.success("Dados atualizados com sucesso!");
      } else if (!response) {
        newUser === null
          ? toast.error(
              "Erro ao salvar dados, verifique os dados e tente novamente!"
            )
          : toast.error(
              "Erro ao atualizar dados, verifique os dados e tente novamente!"
            );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        newUser === null
          ? toast.error(
              "Erro ao salvar dados, verifique os dados e tente novamente!"
            )
          : toast.error(
              "Erro ao atualizar dados, verifique os dados e tente novamente!"
            );
      }
    } finally {
      getAllData();
    }
  };

  const HandleSubmit = (values) => {
    sendData(values);
  };
  useEffect(() => getAllRoles(), []);

  async function getAllRoles() {
    setIsLoading(true);

    try {
      const response = await api.get(`/api/papel?page=0&size=2000`);
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content;
        setListRoles(content);
      } else if (!response) {
        toast.error("Erro ao buscar os dados, tente novamente mais tarde!");
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar os dados, tente novamente mais tarde!");
      }
    } finally {
      setIsLoading(false);
    }
  }

  const selectAutocomplete = async (item) => {
    if (typeof item === "string") return;

    setSelected(true);
    setRoleId(item?.id);
    setInitialState({
      ...initialState,
      roleName: item?.cpfCnpj || "",
      roleId: item?.id || "",
    });
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <Formik
            initialValues={initialState}
            onSubmit={async (values) => HandleSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <div className="boxSearch">
                  <InputMask
                    type="text"
                    name="addCPF"
                    alwaysShowMask={false}
                    value={values.addCPF}
                    onChange={(e) => {
                      onBlurCPF(desmaskIfNumber(e.target.value));
                      setFieldValue("addCPF", e.target.value);
                    }}
                    maskChar=""
                    mask={"999.999.999-99"}
                  />

                  <S.SelectContainer>
                    <BorderedAutoCompleteSearchRoles
                      label="Selecione um papel"
                      listRoles={listRoles}
                      selected={selected}
                      handleSearch={selectAutocomplete}
                      initialValue={initialState.role}
                    />
                  </S.SelectContainer>

                  <Button
                    type="submit"
                    className="button"
                    onClick={() => HandleSubmit(desmaskIfNumber(values.addCPF))}
                  >
                    Permitir acesso
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
          <S.CardHeader>
            <span>
              {`${totalElements} usuário${
                totalElements > 1 ? "s" : ""
              } cadastrado${totalElements > 1 ? "s" : ""} no sistema`}
            </span>
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {users &&
                users?.map((user) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info>
                          <img src={iconUser} alt="Icone usuário" />
                          <div className="dataCard">
                            <h4>CPF:</h4>
                            <h4>Nome:</h4>
                            <h4>Papel:</h4>
                            <h4>Data de registro:</h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {mask(user?.cpf, "###.###.###-##", true)}
                            </h4>
                            <h4 className="h4-info">{user?.nome || " - "}</h4>
                            <h4 className="h4-info">
                              {user?.papel?.nome || " - "}
                            </h4>
                            <h4 className="h4-info">
                              {user?.dataRegistro !== null
                                ? new Date(
                                    user?.dataRegistro
                                  ).toLocaleDateString("pt-BR")
                                : " - "}
                            </h4>
                          </div>
                        </S.Info>
                        <div className="iconService">
                          <BiTrash
                            id="trashIcon"
                            color="#00a2e0"
                            size={25}
                            onClick={() => {
                              setPopupOpen(true);
                              setUserSelected({ id: user.id, cpf: user.cpf });
                            }}
                          />
                        </div>
                      </S.Custumer>
                    </>
                  );
                })}

              {totalPages > 1 && (
                <TablePagination
                  component="div"
                  classes={{
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                  }}
                  count={totalElements}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return from + " - " + to + " de " + count;
                  }}
                  onPageChange={(p, newPage) => reloadPage(newPage)}
                  rowsPerPageOptions={[]}
                  rowsPerPage={pageLimit}
                />
              )}
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
        </S.Card>
      </S.Container>
      {popupOpen && (
        <PopUp
          setIsLoading={setIsLoading}
          setOpenPopup={setPopupOpen}
          userSelected={userSelected}
          page={page}
          updateList={getAllData}
          endPoint="/api/whitelist/"
          useMask="###.###.###-##"
          inativar={false}
          showCpfCnpj={true}
          textExclude={"Você deseja realmente excluir este usuário?"}
          messageFailed={"Error ao excluir o usuário com o CPF"}
          messageSuccess={"Sucesso ao excluir o usuário"}
        />
      )}
    </>
  );
}
